var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"labelRequiredField"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('span',{staticClass:"mandatory-data"},[_vm._v("*")]),(_vm.information)?_c('b-form-text',[_vm._v(_vm._s(_vm.information))]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }